module.exports = __webpack_public_path__ + "public/images/netw-choose-company-desktop.834ffccd150384c9ea922f85796349b7.jpg";